import { render, staticRenderFns } from "./DefaultSignLoading.component.vue?vue&type=template&id=36118942"
import script from "./DefaultSignLoading.component.vue?vue&type=script&lang=js"
export * from "./DefaultSignLoading.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports